<div class="search">
  <div class="search__header" >
    <button [uppercase]="false" app-button buttonType="default" buttonTheme="light" class="mr-4" (click)="goBack()" *ngIf="!(loading$ | async) && (query$ | async)?.length">
      <fa-icon
        icon="chevron-left"
        class="search__navigate mr-2">
      </fa-icon>
      <span class="text-semibold text-14">
        Showing {{ (searchResults$ | async)?.length }} results for <span class="search__term">{{ query$ | async }}</span>
      </span>
    </button>

    <app-gallery-view-mode></app-gallery-view-mode>
  </div>
  
  <div class="search__results">
    <app-gallery-results
      [loading]="loading$ | async"
      [results]="searchResults$ | async" 
      [checkable]="false"
      (selectBookmark)="handleSelectBookmark($event)"
      [viewMode]="viewMode$ | async"
      [showActions]="true"
      selectLabel="View"
      *ngIf="searchResults$ | async">
    
      <ng-template #galleryActions let-item>
        <app-bookmark-actions
            theme="light"
            [bookmark]="item" 
            [bookmarkType]="item.type"
            [bookmarkEmbedTypes]="['bookmark', 'module']"
            [bookmarkActions]="[bookmarkActions.View, bookmarkActions.CopyLink, bookmarkActions.CopyBookmark, bookmarkActions.Edit, bookmarkActions.Share]">
        </app-bookmark-actions>
      </ng-template>

      <ng-template #galleryTags let-item>
        <app-list listType="commafied">
          <!-- Premium -->
          <app-list-item *ngIf="item.premium && !(isPremiumUser$ | async)">
            <fa-icon icon="lock"></fa-icon> Premium
          </app-list-item>

          <!-- Animated -->
          <app-list-item *ngIf="item.animated">
            Animated
          </app-list-item>

          <!-- Tour -->
          <app-list-item *ngIf="item.tour">Tour</app-list-item>
        </app-list>
      </ng-template>
    
    </app-gallery-results>
  
  </div>
</div>